
const VERSION = {
  SHA1:'cd9e86784a5adb3093f4767d8bbe552c2e3137be',
  VERSION:2346,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
